import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { withConfig } from 'src/withConfig';



export const RaceSummaryCaption = withConfig(theme => styled('div', { label: 'RaceSummaryCaption' })`

    background: ${theme.star.raceSummary.bgColorSecondary};

    border: 1px solid ${theme.star.raceSummary.borderColor};

    color: ${theme.star.raceSummary.txtColorTertiary};

    display: flex;

    flex-flow: row nowrap;

    font-size: ${theme.star.fontSize.xSmall};

    justify-content: space-between;

    line-height: 1.4;

`);







const setRaceCell = (theme: EmotionTheme): SerializedStyles => css`

    align-items: center;

    display: flex;

    font-size: ${theme.star.fontSize.xSmall};

    justify-content: center;

`;



interface PropsType {

    isRaceInProgress?: boolean;

    variant: DefaultComponentVariantType | null;

}



const setSelectionCaption = (variant: DefaultComponentVariantType | null, theme: EmotionTheme, isRaceInProgress?: boolean): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            margin-right: 4px;

        `;

    }

    return css`

        border-left: 1px solid ${theme.star.raceSummary.borderColor};

        margin-right: ${isRaceInProgress === true ? '1px' : '0'};

    `;

};



export const SelectionCaption = withConfig(theme => styled('span', { label: 'SelectionCaption' })<PropsType>`

    ${setRaceCell(theme)};

    ${({ variant, isRaceInProgress }): SerializedStyles=> setSelectionCaption(variant, theme, isRaceInProgress)};

    flex: 0 0 48px;

    font-weight: ${theme.star.fontWeight.xMedium};

    padding: 1px 4px;

    text-align: center;

    @media ${theme.star.mediaQuery.tablet} {

        flex: 0 0 64px;

        margin-left: -1px;

    }

`);



interface RaceSummaryRowPropsType {

    isNonRunner?: boolean;

    isExpanded?: boolean;

    variant: DefaultComponentVariantType | null;

}



const setRaceSummaryRow = (variant: DefaultComponentVariantType | null, theme: EmotionTheme, isExpanded?: boolean): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            padding: ${theme.star.padding.small};

            gap: ${theme.star.gap.small};

            border-radius: ${isExpanded === true ? `${theme.star.radius.medium} ${theme.star.radius.medium} 0 0` : theme.star.radius.medium};

            min-height: 60px;

            @media ${theme.star.mediaQuery.tablet} {

                min-height: 48px;

            }

        `;

    }

    return css`

        border-bottom: 1px solid ${theme.star.raceSummary.borderColor};

        min-height: 72px;

        @media ${theme.star.mediaQuery.tablet} {

            border-left: 1px solid  ${theme.star.raceSummary.borderColor};

            min-height: 64px;

        }

    `;

};



export const RaceSummaryRow = withConfig(theme => styled('li', { label: 'RaceSummaryRow' })<RaceSummaryRowPropsType>`

    ${({ variant, isExpanded }): SerializedStyles=> setRaceSummaryRow(variant, theme, isExpanded)};

    background-color: ${theme.star.raceSummary.bgColor};

    color: ${theme.star.raceSummary.txtColor};

    display: flex;

    flex-flow: row nowrap;

    justify-content: space-between;

    opacity: ${({ isNonRunner }): number => isNonRunner === true ? 0.4 : 1};

    position: relative;

`);

